module.exports = __webpack_public_path__ + "static/work23-92a1cd5e4f2398440901515cdc27b66e.jpg";